import { useEffect } from "react";
import "./iAmAStyles.css";

const IAmA = () => {
  class TxtType {
    constructor(el, toRotate, period) {
      this.toRotate = toRotate;
      this.el = el;
      this.loopNum = 0;
      this.period = parseInt(period, 10) || 2000;
      this.txt = "";
      this.tick();
      this.isDeleting = false;
    }
    tick() {
      var i = this.loopNum % this.toRotate.length;
      var fullTxt = this.toRotate[i];

      if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
      } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
      }

      this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

      var that = this;
      var delta = 200 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === "") {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(function () {
        that.tick();
      }, delta);
    }
  }

  useEffect(() => {
    window.onload = type();
    // eslint-disable-next-line
  }, []);

  const type = () => {
    var elements = document.getElementsByClassName("typewrite");
    for (var i = 0; i < elements.length; i++) {
      var toRotate = elements[i].getAttribute("data-type");
      var period = elements[i].getAttribute("data-period");
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }
  };

  return (
    <>
      <div className="credContainer" id="credContainer">
        <img src="/pattern.png" className="lines" alt="pattern" />
        <div className="credText">
          I am a{" "}
          <span
            className="typewrite"
            data-period="1000"
            data-type='[ "Software Developer", "Full-Stack Engineer", "Content Creator", "Digital Art Enthusiast", "Tech Blogger"]'
          >
            <span className="wrap"></span>
          </span>
        </div>
      </div>
    </>
  );
};

export default IAmA;
